import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';
import { catchError, map, Observable, of } from 'rxjs';
import { TokenStorage } from '../core/token-storage';
import { Credential } from '../models/credential';
import { Token } from '../models/token';
import { User } from '../models/user';
import { UsersService } from './users.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationService extends ServiceBase {
    constructor(
        private http: HttpClient,
        private userService: UsersService,
        private tokenStorage: TokenStorage
    ) {
        super();
    }

    login(account: string, password: string): Observable<boolean> {
        const credential = new Credential(account, password);

        // Ajoute un Identifiant de session
        sessionStorage.setItem('SessionId', Guid.create().toString());

        let isAuthentified: boolean = false;

        return this.http
            .post(`${this.baseUrl}/api/token`, credential, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
            })
            .pipe(
                map((response: Token) => {
                    if (response.accessToken) {
                        // Enregistre le token
                        this.tokenStorage.saveToken(response.accessToken);
                        // Enregistre en session le compte de l'utilisateur en attendant la récupération de ses informations
                        const user = new User();
                        user.account = account;
                        sessionStorage.setItem('passwordExpireOn', response.passwordExpireOn.toString());
                        sessionStorage.setItem('user', JSON.stringify(user));
                        isAuthentified = true;
                    } else {
                        isAuthentified = false;
                    }

                    return isAuthentified;
                }),
                catchError(() => {
                    return of(false);
                })
            );
    }

    logout(account: string) {
        const params = new HttpParams().set('account', account);

        this.http.delete(`${this.baseUrl}/api/token`, { params: params }).subscribe();

        this.userService.removeCurrentUser();

        // Supprime le token
        this.tokenStorage.signOut();
    }
}
